<template>
  <v-dialog v-model="navigation.CRMLocalityDialogIsVisible" max-width="85vw" persistent>
   <v-card max-width="85vw" style="padding: 15px; text-align: center;">
      <div v-if="navigation.deleteCRMLocality">
        <p>¿Está seguro de que desea eliminar la localidad <strong>{{ navigation.CRMLocality.CRMLocalityName }}</strong>?</p>
        <p>Esta acción no se puede deshacer</p>
      </div>
      <div v-else> 
        <div v-if="loader.selectCRMLocalityFromCRMLocalityDialog" style="width: 100%; text-align: center;">
          <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
        </div>
        <div v-else>
          <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-switch 
                v-bind="props" 
                v-model="input.CRMLocalityIsVisible" 
                color="primary" 
                :label="`La localidad será visible${navigation.CRMLocality ? '' : ' desde su creación'}`" 
                hide-details
              ></v-switch>
            </template>
            <span style="max-width: 400px; display: block;">La visibilidad de la localidad determina si una localidad será o no visible desde otras partes de la aplicación que no sea la vista de localidades</span>
          </v-tooltip>
          <br>
          <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-text-field 
                v-bind="props"
                ref="CRMLocalityName"
                v-model="input.CRMLocalityName" 
                :append-inner-icon="input.CRMLocalityName ? 'mdi-store-minus' : 'mdi-store'" 
                @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMLocalityName'); input.CRMLocalityName = null" 
                label="Nombre de la localidad" 
                variant="solo-filled" 
                density="compact"
              ></v-text-field>
            </template>
            <span style="max-width: 400px; display: block;">El nombre de la localidad. Se recomienda no repetir nombres para facilitar su diferenciación</span>
          </v-tooltip>
          <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-textarea 
                v-bind="props"
                ref="CRMLocalityDescription"
                v-model="input.CRMLocalityDescription" 
                :append-inner-icon="input.CRMLocalityDescription ? 'mdi-alphabetical-off' : 'mdi-alphabetical'" 
                @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMLocalityDescription'); input.CRMLocalityDescription = null" 
                label="Descripción de la localidad (opcional)" 
                variant="solo-filled" 
                density="compact"
                rows="3"
              ></v-textarea>
            </template>
            <span style="max-width: 400px; display: block;">La descripción de la localidad. Es un espacio opcional destinado a detallar el contenido o función de la localidad</span>
          </v-tooltip>
          <div style="display: flex; gap: 20px;">
            <div style="flex: 1; min-width: 300px;">
              <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-text-field 
                    v-bind="props"
                    ref="CRMLocalityColor"
                    @click="navigation.CRMLocalityColorDialogIsVisible = true" 
                    @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMLocalityColor'); input.CRMLocalityColor = null;"
                    :append-inner-icon="input.CRMLocalityColor ? 'mdi-palette-outline' : 'mdi-palette'"
                    v-model="input.CRMLocalityColor" 
                    :bg-color="input.CRMLocalityColor" 
                    readonly="true" 
                    label="Color de la localidad" 
                    variant="solo-filled"
                    density="compact"
                  ></v-text-field>
                </template>
                <v-dialog v-model="navigation.CRMLocalityColorDialogIsVisible" width="auto">
                  <v-card width="300">
                    <v-color-picker 
                      v-model="input.CRMLocalityColor" 
                      :modes="['hex']" 
                      show-swatches
                    ></v-color-picker>
                  </v-card>
                </v-dialog>
                <span style="max-width: 400px; display: block;">El color de fondo de la localidad. Se recomienda no repetir colores para facilitar su diferenciación</span>
              </v-tooltip>
            </div>
            <div style="flex: 1; min-width: 300px;">
              <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-text-field 
                    v-bind="props"
                    ref="CRMLocalityFontColor"
                    @click="navigation.CRMLocalityFontColorDialogIsVisible = true" 
                    @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMLocalityFontColor'); input.CRMLocalityFontColor = null;"
                    :append-inner-icon="input.CRMLocalityFontColor ? 'mdi-palette-outline' : 'mdi-palette'"
                    v-model="input.CRMLocalityFontColor" 
                    :bg-color="input.CRMLocalityFontColor" 
                    readonly="true"
                    label="Color de fuente de la localidad"
                    variant="solo-filled"
                    density="compact"
                  ></v-text-field>
                </template>
                <v-dialog v-model="navigation.CRMLocalityFontColorDialogIsVisible" width="auto">
                  <v-card width="300">
                    <v-color-picker 
                      v-model="input.CRMLocalityFontColor" 
                      :modes="['hex']" 
                      show-swatches
                    ></v-color-picker>
                  </v-card>
                </v-dialog>
                <span style="max-width: 400px; display: block;">El color de fuente de la localidad. Se recomienda no repetir colores para facilitar su diferenciación</span>
              </v-tooltip>
            </div>
          </div>
          <br>
          <v-card color="border" style="padding: 15px;">
            <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
              <template v-slot:activator="{ props }">
                <v-switch 
                  @click="$event.preventDefault(); this.navigation.updateCRMLocalityIsDeliveryDialogIsVisible = true;"
                  v-bind="props" 
                  v-model="input.CRMLocalityIsDelivery" 
                  color="primary" 
                  :label="`La localidad entregará por envío`" 
                  hide-details
                ></v-switch>
              </template>
              <span style="max-width: 400px; display: block;">Si una localidad entrega por envío, es necesario definir su zona geográfica de entrega</span>
            </v-tooltip>
            <v-dialog v-model="navigation.updateCRMLocalityIsDeliveryDialogIsVisible" width="30vw">
              <v-card width="30vw" style="padding: 15px; text-align: center;">  
                <p>Si se cambia el estado de entrega por envío, el mapa se reiniciará y perderá todo el progreso</p>
                <br>
                <p>¿Desea continuar?</p>
                <br>
                <v-btn @click="input.CRMLocalityIsDelivery = !input.CRMLocalityIsDelivery; navigation.updateCRMLocalityIsDeliveryDialogIsVisible = false; navigation.CRMLocalityMapKey = Math.random().toString(36).substring(2, 11); input.CRMLocalityMapCenter = null; input.CRMLocalityMapPoints.length = 0; input.CRMLocalityMapDivisions.length = 0; input.CRMLocalityBusinessHours = null;" color="success" dark block height="38" style="margin-bottom: 10px;">
                  <h3>ACEPTAR</h3>
                  <v-icon style="margin-left: 10px;" dark right>mdi-check-circle-outline</v-icon>
                </v-btn>
                <v-btn @click="navigation.updateCRMLocalityIsDeliveryDialogIsVisible = false" color="error" dark block height="38">
                  <h3>CANCELAR</h3>
                  <v-icon style="margin-left:10px;" dark right>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card>
            </v-dialog>
            <br>
            <MapComponent 
              :key="navigation.CRMLocalityMapKey"
              :width="'100%'"
              :height="'700px'"
              :creationMap="true" 
              :creationMapPolygon="input.CRMLocalityIsDelivery"
              :creationMapName="input.CRMLocalityName || 'Localidad'"
              :creationMapColor="input.CRMLocalityColor || '#000000'" 
              :creationMapFontColor="input.CRMLocalityFontColor || '#000000'"
              :displayMaps="
                display.CRMLocalities.map(CRMLocality => 
                ({
                  'mapID': CRMLocality.CRMLocalityID,
                  'mapName': CRMLocality.CRMLocalityName, 
                  'mapColor': CRMLocality.CRMLocalityColor, 
                  'mapFontColor': CRMLocality.CRMLocalityFontColor, 
                  'mapCenterLatitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 
                  'mapCenterLongitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude, 
                  'mapPoints': CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                  ({
                    'mapPointLatitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                    'mapPointLongitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                  })), 
                  'mapDivisions': CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                  ({
                    'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 
                    'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                    'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                    'mapDivisionIsDisplayOnly': CRMLocalityMapDivision.CRMLocalityMapDivisionIsDisplayOnly,
                    'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                    ({
                      'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                      'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                    }))
                  }))
                }))"
              @creationMapPolygonUpdate="input.CRMLocalityMapPoints = $event.creationMapPolygonCoordinates.map(polygonCoordinate => ({'CRMLocalityMapPointLatitude': polygonCoordinate[1], 'CRMLocalityMapPointLongitude': polygonCoordinate[0]}))"
              @creationMapPointUpdate="input.CRMLocalityMapCenter = {'CRMLocalityMapCenterLatitude': $event.creationMapPointCoordinates[1], 'CRMLocalityMapCenterLongitude': $event.creationMapPointCoordinates[0]}"
              @creationMapDivisionsUpdate="input.CRMLocalityMapDivisions = $event.creationMapDivisions.map(division => ({'CRMLocalityMapDivisionName': division.divisionName, 'CRMLocalityMapDivisionDescription': division.divisionDescription, 'CRMLocalityMapDivisionColor': division.divisionColor, 'CRMLocalityMapDivisionPoints': division.divisionPoints.map(divisionPoint => ({'CRMLocalityMapDivisionPointLatitude': divisionPoint[1], 'CRMLocalityMapDivisionPointLongitude': divisionPoint[0]}))}))"
            />
            <br>
            <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
              <template v-slot:activator="{ props }">
                <v-textarea 
                  v-bind="props"
                  ref="CRMLocalityAddress"
                  @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMLocalityAddress'); input.CRMLocalityAddress = null;"
                  :append-inner-icon="input.CRMLocalityAddress ? 'mdi-map-marker-off' : 'mdi-map-marker'"
                  v-model="input.CRMLocalityAddress" 
                  label="Dirección en señas de la localidad (opcional)"
                  placeholder="Calle 123, Ciudad, País"
                  rows="3"
                  variant="solo-filled"
                  density="compact"
                ></v-textarea>
              </template>
              <span style="max-width: 400px; display: block;">La dirección en señas de la localidad. Se enviará junto con el mensaje de ubicación de la localidad</span>
            </v-tooltip>
            <v-tooltip :disabled="localStorage.tooltipDisabled" open-delay="2000" location="top">
              <template v-slot:activator="{ props }">
                <v-textarea 
                  v-bind="props"
                  ref="CRMLocalityBusinessHours"
                  @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMLocalityBusinessHours'); input.CRMLocalityBusinessHours = null;"
                  :append-inner-icon="input.CRMLocalityBusinessHours ? 'mdi-calendar-remove-outline' : 'mdi-calendar'"
                  v-model="input.CRMLocalityBusinessHours" 
                  label="Horario de atención de la localidad (opcional)"
                  placeholder="Lunes a Viernes: 9:00 - 18:00&#10;Sábados: 10:00 - 14:00&#10;Domingos: Cerrado"
                  rows="3"
                  variant="solo-filled"
                  density="compact"
                ></v-textarea>
              </template>
              <span style="max-width: 400px; display: block;">El horario de atención de la localidad. Se enviará junto con el mensaje de ubicación de la localidad</span>
            </v-tooltip>
          </v-card>
          <br>
          <br>
          <v-tooltip :disabled="validateInputForCRMLocalityDialog(false).success" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn 
                  @click="navigation.CRMLocality ? (navigation.deleteCRMLocality ? deleteCRMLocality() : updateCRMLocality()) : insertCRMLocality()" 
                  :disabled="!validateInputForCRMLocalityDialog(false).success" 
                  :color="navigation.deleteCRMLocality ? 'error' : 'success'" 
                  dark 
                  block 
                  height="38" 
                  style="margin-bottom: 10px;"
                >
                  <h3>{{ navigation.CRMLocality ? (navigation.deleteCRMLocality ? 'ELIMINAR' : 'ACTUALIZAR') : 'AGREGAR' }} LOCALIDAD</h3>
                  <v-icon style="margin-left: 10px;" dark right>{{ navigation.CRMLocality ? (navigation.deleteCRMLocality ? 'mdi-delete-circle-outline' : 'mdi-update') : 'mdi-plus-circle-outline' }}</v-icon>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForCRMLocalityDialog(false).result }}</span>
          </v-tooltip>
          <v-btn @click="navigation.CRMLocalityDialogIsVisible = false" :color="navigation.deleteCRMLocality ? 'info' : 'error'" dark block height="38">
            <h3>CANCELAR</h3>
            <v-icon style="margin-left:10px;" dark right>mdi-close-circle-outline</v-icon>
          </v-btn>
        </div>
      </div>
   </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import MapComponent from '@/components/MapComponent.vue';
  import componentConnector from '@/utilities/componentConnector';

  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: 
    { 
      MapComponent
    },

    data: () => 
    ({
      input: 
      {
        CRMLocalityIsVisible: true,
        CRMLocalityName: null,
        CRMLocalityDescription: null,
        CRMLocalityAddress: null,
        CRMLocalityBusinessHours: null,
        CRMLocalityColor: null,
        CRMLocalityFontColor: null,
        CRMLocalityIsDelivery: false,
        CRMLocalityMapCenter: null,
        CRMLocalityMapPoints: [],
        CRMLocalityMapDivisions: []
      },
      display: 
      {
        CRMLocalities: []
      },
      navigation: 
      {
        CRMLocalityDialogIsVisible: false,
        CRMLocalityMapKey: null,
        CRMLocalityColorDialogIsVisible: false,
        CRMLocalityFontColorDialogIsVisible: false,
        updateCRMLocalityIsDeliveryDialogIsVisible: false
      },
      loader: 
      {
        selectCRMLocalityFromCRMLocalityDialog: false,
        insertCRMLocality: false,
        updateCRMLocality: false,
        deleteCRMLocality: false,
      },
      asset: {},
      localStorage: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        tooltipDisabled: false
      },
      interval: {}
    }),

    methods:
    {
      async selectCRMLocalityFromCRMLocalityDialog(){
        this.loader.selectCRMLocalityFromCRMLocalityDialog = true;
        const selectCRMLocalityFromCRMLocalityDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.localStorage.CRMAccountID
          }
        };
        const selectCRMLocalityFromCRMLocalityDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMLocality/functions/selectCRMLocalityFromCRMLocalityDialog', selectCRMLocalityFromCRMLocalityDialogRequestQuery);
        if (selectCRMLocalityFromCRMLocalityDialogResult.success){
          this.display.CRMLocalities = selectCRMLocalityFromCRMLocalityDialogResult.result;
          this.loader.selectCRMLocalityFromCRMLocalityDialog = false;
        } else {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ERROR',
            'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la lista de localidades, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
            'notificationDialogColor': 'error',
            'notificationDialogIsPersistent': false
          });
        }
        this.loader.selectCRMLocalityFromCRMLocalityDialog = false;
      },


      async insertCRMLocality(){
        if (this.validateInputForCRMLocalityDialog(true).success){
          this.loader.insertCRMLocality = true;
          const insertCRMLocalityRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.localStorage.CRMAccountID,
              'CRMAgentID': this.localStorage.CRMAgentID
            },
            'CRMLocalityName': this.input.CRMLocalityName,
            'CRMLocalityDescription': this.input.CRMLocalityDescription,
            'CRMLocalityAddress': this.input.CRMLocalityAddress,
            'CRMLocalityBusinessHours': this.input.CRMLocalityBusinessHours,
            'CRMLocalityColor': this.input.CRMLocalityColor,
            'CRMLocalityFontColor': this.input.CRMLocalityFontColor,
            'CRMLocalityIsDelivery': this.input.CRMLocalityIsDelivery,
            'CRMLocalityIsVisible': this.input.CRMLocalityIsVisible,
            'CRMLocalityMapCenter': this.input.CRMLocalityMapCenter,
            'CRMLocalityMapPoints': this.input.CRMLocalityMapPoints,
            'CRMLocalityMapDivisions': this.input.CRMLocalityMapDivisions,
          };        
          const insertCRMLocalityResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMLocality/functions/insertCRMLocality', insertCRMLocalityRequestQuery);
          if (insertCRMLocalityResult.success){
            this.navigation.CRMLocalityDialogIsVisible = false;
            this.$root.notificationDialog.showNotificationDialog({
              'notificationDialogTitle': 'ÉXITO',
              'notificationDialogBody': 'Se ha agregado la localidad exitosamente',
              'notificationDialogColor': 'success',
              'notificationDialogIsPersistent': false
            });
            componentConnector.componentConnection.emit('CRMLocalitiesView/methods/selectCRMLocalityFromCRMLocalityView()');
          } else {
            this.$root.notificationDialog.showNotificationDialog({
              'notificationDialogTitle': 'ERROR',
              'notificationDialogBody': 'Ha ocurrido un error inesperado al agregar la localidad, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
              'notificationDialogColor': 'error',
              'notificationDialogIsPersistent': false
            });
          }
          this.loader.insertCRMLocality = false;
        }
      },

      updateCRMLocality(){
        this.loader.updateCRMLocality = true;
      },

      deleteCRMLocality(){
        this.loader.deleteCRMLocality = true;
      },

      validateInputForCRMLocalityDialog(showNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.input.CRMLocalityName != null && regularExpressionChecker.test(this.input.CRMLocalityName)){
          if (this.input.CRMLocalityName.length <= 100){
            if (this.input.CRMLocalityDescription == null || this.input.CRMLocalityDescription.length <= 65535){
              if (this.input.CRMLocalityColor != null){
                if (this.input.CRMLocalityFontColor != null){
                  if (this.input.CRMLocalityMapCenter != null){
                    if (this.input.CRMLocalityIsDelivery == false || this.input.CRMLocalityMapPoints.length > 0){
                      if (this.input.CRMLocalityBusinessHours == null || this.input.CRMLocalityBusinessHours.length <= 100){
                        if (this.input.CRMLocalityAddress == null || this.input.CRMLocalityAddress.length <= 100){
                          return {success: true, result: null};
                        } else {
                          if (showNotificationDialog){
                            this.$root.notificationDialog.showNotificationDialog({
                              'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
                              'notificationDialogBody': 'La dirección en señas de la localidad no puede exceder los 100 caracteres de longitud',
                              'notificationDialogColor': 'warning',
                              'notificationDialogIsPersistent': false
                            });
                          }
                          return {success: false, result: 'La dirección en señas de la localidad no puede exceder los 100 caracteres de longitud'};
                        }
                      } else {
                        if (showNotificationDialog){
                          this.$root.notificationDialog.showNotificationDialog({
                            'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
                              'notificationDialogBody': 'El horario de atención de la localidad no puede exceder los 100 caracteres de longitud',
                              'notificationDialogColor': 'warning',
                              'notificationDialogIsPersistent': false
                            });
                          }
                          return {success: false, result: 'El horario de atención de la localidad no puede exceder los 100 caracteres de longitud'};
                        }
                      } else {
                        if (showNotificationDialog){
                        this.$root.notificationDialog.showNotificationDialog({
                          'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
                          'notificationDialogBody': 'La ubicación de la localidad es obligatoria',
                          'notificationDialogColor': 'warning',
                          'notificationDialogIsPersistent': false
                        });
                      }
                      return {success: false, result: 'La ubicación de la localidad es obligatoria'};
                    }
                  } else {
                    if (showNotificationDialog){
                      this.$root.notificationDialog.showNotificationDialog({
                        'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
                        'notificationDialogBody': 'La ubicación de la localidad es obligatoria',
                        'notificationDialogColor': 'warning',
                        'notificationDialogIsPersistent': false
                      });
                    }
                    return {success: false, result: 'La ubicación de la localidad es obligatoria'};
                  }
                } else {
                  if (showNotificationDialog){
                    this.$root.notificationDialog.showNotificationDialog({
                      'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
                      'notificationDialogBody': 'El color de fuente de la localidad es obligatorio',
                      'notificationDialogColor': 'warning',
                      'notificationDialogIsPersistent': false
                    });
                  }
                  return {success: false, result: 'El color de fuente de la localidad es obligatorio'};
                }
              } else {
                if (showNotificationDialog){
                  this.$root.notificationDialog.showNotificationDialog({
                    'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
                    'notificationDialogBody': 'El color de la localidad es obligatorio',
                    'notificationDialogColor': 'warning',
                    'notificationDialogIsPersistent': false
                  });
                }
                return {success: false, result: 'El color de la localidad es obligatorio'};
              }
            } else {
              if (showNotificationDialog){
                this.$root.notificationDialog.showNotificationDialog({
                  'notificationDialogTitle': 'INFORMACIÓN INCORRECTA',
                  'notificationDialogBody': 'La descripción de la localidad no puede exceder los 65535 caracteres de longitud',
                  'notificationDialogColor': 'warning',
                  'notificationDialogIsPersistent': false
                });
              }
              return {success: false, result: 'La descripción de la localidad no puede exceder los 65535 caracteres de longitud'};
            }
          } else { 
            if (showNotificationDialog){
              this.$root.notificationDialog.showNotificationDialog({
                'notificationDialogTitle': 'INFORMACIÓN INCORRECTA',
                'notificationDialogBody': 'El nombre de la localidad no puede exceder los 100 caracteres de longitud',
                'notificationDialogColor': 'warning',
                'notificationDialogIsPersistent': false
              });
            }
            return {success: false, result: 'El nombre de la localidad no puede exceder los 100 caracteres de longitud'};
          }
        } else {
          if (showNotificationDialog){
            this.$root.notificationDialog.showNotificationDialog({
              'notificationDialogTitle': 'INFORMACIÓN INCOMPLETA',
              'notificationDialogBody': 'El nombre de la localidad es obligatorio',
              'notificationDialogColor': 'warning',
              'notificationDialogIsPersistent': false
            });
          }
          return {success: false, result: 'El nombre de la localidad es obligatorio'};
        }
      },

      getLocalStorageData(){
        this.localStorage.CRMAccountID = localStorage.getItem('CRMAccountID');
        this.localStorage.CRMAgentID = localStorage.getItem('CRMAgentID');
        this.localStorage.tooltipDisabled = localStorage.getItem('tooltipDisabled') == 'true';
      },

      openCRMLocalityDialog(CRMLocalityDialogRequestQuery){
        this.navigation.CRMLocality = CRMLocalityDialogRequestQuery.CRMLocality;
        this.input.CRMLocalityName = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityName : null;
        this.input.CRMLocalityDescription = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityDescription : null;
        this.input.CRMLocalityAddress = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityAddress : null;
        this.input.CRMLocalityBusinessHours = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityBusinessHours : null;
        this.input.CRMLocalityColor = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityColor : null;
        this.input.CRMLocalityFontColor = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityFontColor : null;
        this.input.CRMLocalityIsDelivery = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityIsDelivery : false;
        this.input.CRMLocalityMapCenter = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityMap.CRMLocalityMapCenter : null;
        this.input.CRMLocalityMapPoints = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityMap.CRMLocalityMapPoints : [];
        this.input.CRMLocalityMapDivisions = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions : [];
        this.navigation.CRMLocalityMapKey = Math.random().toString(36).substring(2, 11);
        this.input.CRMLocalityShowRoute = this.navigation.CRMLocality ? this.navigation.CRMLocality.CRMLocalityShowRoute : false;
        this.display.CRMLocalities.length = 0;
        this.navigation.deleteCRMLocality = CRMLocalityDialogRequestQuery.deleteCRMLocality;
        this.navigation.CRMLocalityColorDialogIsVisible = false;
        this.navigation.CRMLocalityFontColorDialogIsVisible = false;
        this.navigation.updateCRMLocalityIsDeliveryDialogIsVisible = false;
        this.loader.insertCRMLocality = false;
        this.loader.updateCRMLocality = false;
        this.loader.deleteCRMLocality = false;
        this.loader.selectCRMLocalityFromCRMLocalityDialog = false;
        this.getLocalStorageData();
        this.selectCRMLocalityFromCRMLocalityDialog();
        this.navigation.CRMLocalityDialogIsVisible = true;
      }
    },

    mounted(){}
  }
</script>